import * as React from 'react';
import {
  InfiniteScrollSelect,
  type InfiniteScrollSelectProps,
} from '../infinite-scroll-select';
import type {SelectValue} from '../_select-internals';
import type {ReactNode} from 'react';

type InfiniteScrollMultiSelectProps<
  T = unknown,
  V extends SelectValue = string,
  L extends ReactNode = string,
> = Omit<Extract<InfiniteScrollSelectProps<T, V, L>, {isMulti: true}>, 'isMulti'>;

const InfiniteScrollMultiSelect = React.forwardRef(function InfiniteScrollMultiSelect<
  T = unknown,
  V extends SelectValue = string,
  L extends ReactNode = string,
>(props: InfiniteScrollMultiSelectProps<T, V, L>, ref: React.Ref<HTMLDivElement>) {
  const Forwarded = InfiniteScrollSelect as unknown as (
    props: InfiniteScrollMultiSelectProps<T, V, L> & {
      ref?: React.Ref<HTMLDivElement>;
      isMulti?: true;
    },
  ) => React.ReactElement;
  return <Forwarded {...props} ref={ref} isMulti />;
}) as <T = unknown, V extends SelectValue = string, L extends ReactNode = string>(
  props: InfiniteScrollMultiSelectProps<T, V, L> & {ref?: React.Ref<HTMLDivElement>},
) => React.ReactElement;

export {InfiniteScrollMultiSelect};
export type {InfiniteScrollMultiSelectProps};
